const Actions = {
	SET_LOADING: "SET_LOADING",
	SET_SOV_MOBILE_VIEW: "SET_SOV_MOBILE_VIEW",
	SET_SOV_TABLET_VIEW: "SET_SOV_TABLET_VIEW",
	SET_SOV_DESKTOP_VIEW: "SET_SOV_DESKTOP_VIEW",
	UPDATE_LANGUAGE: "UPDATE_LANGUAGE",
	SET_DICTIONARY: "SET_DICTIONARY",
	SET_SESSION_MANAGER: "SET_SESSION_MANAGER",
};

export default Actions;
